import React from "react";

const FeedLayout = ({ children }) => {
  return (
    <div className="qnexus-feed-layout">
      {children}
    </div>
  );
};

export default FeedLayout;
